import React, { PropsWithChildren } from 'react';
import styled, { CSSObject } from '@emotion/styled';
import { mq } from '@/ui-kit/theme';

interface IStyledBoxProps {
  width: CSSObject['width'];
  widthXs?: CSSObject['width'];
  widthSm?: CSSObject['width'];
  widthMd?: CSSObject['width'];
  widthLg?: CSSObject['width'];
  widthXl?: CSSObject['width'];
  direction: CSSObject['flexDirection'];
  directionXs?: CSSObject['flexDirection'];
  directionSm?: CSSObject['flexDirection'];
  directionMd?: CSSObject['flexDirection'];
  directionLg?: CSSObject['flexDirection'];
  directionXl?: CSSObject['flexDirection'];
  justify: CSSObject['justifyContent'];
  justifyXs?: CSSObject['justifyContent'];
  justifySm?: CSSObject['justifyContent'];
  justifyMd?: CSSObject['justifyContent'];
  justifyLg?: CSSObject['justifyContent'];
  justifyXl?: CSSObject['justifyContent'];
  align: CSSObject['alignItems'];
  alignXs?: CSSObject['alignItems'];
  alignSm?: CSSObject['alignItems'];
  alignMd?: CSSObject['alignItems'];
  alignLg?: CSSObject['alignItems'];
  alignXl?: CSSObject['alignItems'];
  grow: CSSObject['flexGrow'];
  growXs?: CSSObject['flexGrow'];
  growSm?: CSSObject['flexGrow'];
  growMd?: CSSObject['flexGrow'];
  growLg?: CSSObject['flexGrow'];
  growXl?: CSSObject['flexGrow'];
  shrink: CSSObject['flexShrink'];
  shrinkXs?: CSSObject['flexShrink'];
  shrinkSm?: CSSObject['flexShrink'];
  shrinkMd?: CSSObject['flexShrink'];
  shrinkLg?: CSSObject['flexShrink'];
  shrinkXl?: CSSObject['flexShrink'];
  gap: CSSObject['gap'];
  gapXs?: CSSObject['gap'];
  gapSm?: CSSObject['gap'];
  gapMd?: CSSObject['gap'];
  gapLg?: CSSObject['gap'];
  gapXl?: CSSObject['gap'];
}

const StyledBox = styled.div<IStyledBoxProps>(({
  width,
  widthXs,
  widthSm,
  widthMd,
  widthLg,
  widthXl,
  direction,
  directionXs,
  directionSm,
  directionMd,
  directionLg,
  directionXl,
  justify,
  justifyXs,
  justifySm,
  justifyMd,
  justifyLg,
  justifyXl,
  align,
  alignXs,
  alignSm,
  alignMd,
  alignLg,
  alignXl,
  grow,
  growXs,
  growSm,
  growMd,
  growLg,
  growXl,
  shrink,
  shrinkXs,
  shrinkSm,
  shrinkMd,
  shrinkLg,
  shrinkXl,
  gap,
  gapXs,
  gapSm,
  gapMd,
  gapLg,
  gapXl,
}) => {
  return {
    display: 'flex',
    width,
    gap,
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexGrow: grow,
    flexShrink: shrink,
    [mq.xs]: {
      ...(widthXs ? { width: widthXs } : {}),
      ...(gapXs ? { gap: gapXs } : {}),
      ...(directionXs ? { flexDirection: directionXs } : {}),
      ...(justifyXs ? { justifyContent: justifyXs } : {}),
      ...(alignXs ? { alignItems: alignXs } : {}),
      ...(growXs ? { flexGrow: growXs } : {}),
      ...(shrinkXs ? { flexShrink: shrinkXs } : {}),
    },
    [mq.sm]: {
      ...(widthSm ? { width: widthSm } : {}),
      ...(gapSm ? { gap: gapSm } : {}),
      ...(directionSm ? { flexDirection: directionSm } : {}),
      ...(justifySm ? { justifyContent: justifySm } : {}),
      ...(alignSm ? { alignItems: alignSm } : {}),
      ...(growSm ? { flexGrow: growSm } : {}),
      ...(shrinkSm ? { flexShrink: shrinkSm } : {}),
    },
    [mq.md]: {
      ...(widthMd ? { width: widthMd } : {}),
      ...(gapMd ? { gap: gapMd } : {}),
      ...(directionMd ? { flexDirection: directionMd } : {}),
      ...(justifyMd ? { justifyContent: justifyMd } : {}),
      ...(alignMd ? { alignItems: alignMd } : {}),
      ...(growMd ? { flexGrow: growMd } : {}),
      ...(shrinkMd ? { flexShrink: shrinkMd } : {}),
    },
    [mq.lg]: {
      ...(widthLg ? { width: widthLg } : {}),
      ...(gapLg ? { gap: gapLg } : {}),
      ...(directionLg ? { flexDirection: directionLg } : {}),
      ...(justifyLg ? { justifyContent: justifyLg } : {}),
      ...(alignLg ? { alignItems: alignLg } : {}),
      ...(growLg ? { flexGrow: growLg } : {}),
      ...(shrinkLg ? { flexShrink: shrinkLg } : {}),
    },
    [mq.xl]: {
      ...(widthXl ? { width: widthXl } : {}),
      ...(gapXl ? { gap: gapXl } : {}),
      ...(directionXl ? { flexDirection: directionXl } : {}),
      ...(justifyXl ? { justifyContent: justifyXl } : {}),
      ...(alignXl ? { alignItems: alignXl } : {}),
      ...(growXl ? { flexGrow: growXl } : {}),
      ...(shrinkXl ? { flexShrink: shrinkXl } : {}),
    },
  };
});

interface IBoxProps {
  width?: CSSObject['width'];
  widthXs?: CSSObject['width'];
  widthSm?: CSSObject['width'];
  widthMd?: CSSObject['width'];
  widthLg?: CSSObject['width'];
  widthXl?: CSSObject['width'];
  direction?: CSSObject['flexDirection'];
  directionXs?: CSSObject['flexDirection'];
  directionSm?: CSSObject['flexDirection'];
  directionMd?: CSSObject['flexDirection'];
  directionLg?: CSSObject['flexDirection'];
  directionXl?: CSSObject['flexDirection'];
  justify?: CSSObject['justifyContent'];
  justifyXs?: CSSObject['justifyContent'];
  justifySm?: CSSObject['justifyContent'];
  justifyMd?: CSSObject['justifyContent'];
  justifyLg?: CSSObject['justifyContent'];
  justifyXl?: CSSObject['justifyContent'];
  align?: CSSObject['alignItems'];
  alignXs?: CSSObject['alignItems'];
  alignSm?: CSSObject['alignItems'];
  alignMd?: CSSObject['alignItems'];
  alignLg?: CSSObject['alignItems'];
  alignXl?: CSSObject['alignItems'];
  grow?: CSSObject['flexGrow'];
  growXs?: CSSObject['flexGrow'];
  growSm?: CSSObject['flexGrow'];
  growMd?: CSSObject['flexGrow'];
  growLg?: CSSObject['flexGrow'];
  growXl?: CSSObject['flexGrow'];
  shrink?: CSSObject['flexShrink'];
  shrinkXs?: CSSObject['flexShrink'];
  shrinkSm?: CSSObject['flexShrink'];
  shrinkMd?: CSSObject['flexShrink'];
  shrinkLg?: CSSObject['flexShrink'];
  shrinkXl?: CSSObject['flexShrink'];
  gap?: CSSObject['gap'];
  gapXs?: CSSObject['gap'];
  gapSm?: CSSObject['gap'];
  gapMd?: CSSObject['gap'];
  gapLg?: CSSObject['gap'];
  gapXl?: CSSObject['gap'];
}

export const Box = ({
  width = 'auto',
  widthXs,
  widthSm,
  widthMd,
  widthLg,
  widthXl,
  direction = 'row',
  directionXs,
  directionSm,
  directionMd,
  directionLg,
  directionXl,
  justify = 'normal',
  justifyXs,
  justifySm,
  justifyMd,
  justifyLg,
  justifyXl,
  align = 'normal',
  alignXs,
  alignSm,
  alignMd,
  alignLg,
  alignXl,
  grow = 0,
  growXs,
  growSm,
  growMd,
  growLg,
  growXl,
  shrink = 1,
  shrinkXs,
  shrinkSm,
  shrinkMd,
  shrinkLg,
  shrinkXl,
  gap = '8px',
  gapXs,
  gapSm,
  gapMd,
  gapLg,
  gapXl,
  children,
}: PropsWithChildren<IBoxProps>) => {
  return (
    <StyledBox
      width={width}
      widthXs={widthXs}
      widthSm={widthSm}
      widthMd={widthMd}
      widthLg={widthLg}
      widthXl={widthXl}
      direction={direction}
      directionXs={directionXs}
      directionSm={directionSm}
      directionMd={directionMd}
      directionLg={directionLg}
      directionXl={directionXl}
      justify={justify}
      justifyXs={justifyXs}
      justifySm={justifySm}
      justifyMd={justifyMd}
      justifyLg={justifyLg}
      justifyXl={justifyXl}
      align={align}
      alignXs={alignXs}
      alignSm={alignSm}
      alignMd={alignMd}
      alignLg={alignLg}
      alignXl={alignXl}
      grow={grow}
      growXs={growXs}
      growSm={growSm}
      growMd={growMd}
      growLg={growLg}
      growXl={growXl}
      shrink={shrink}
      shrinkXs={shrinkXs}
      shrinkSm={shrinkSm}
      shrinkMd={shrinkMd}
      shrinkLg={shrinkLg}
      shrinkXl={shrinkXl}
      gap={gap}
      gapXs={gapXs}
      gapSm={gapSm}
      gapMd={gapMd}
      gapLg={gapLg}
      gapXl={gapXl}
    >
      {children}
    </StyledBox>
  );
};
